
interface Props {
  brands: Brand[];
  tags: Tag[];
  selectedTags: string[];
  selectedBrands: string[];
  onTagChange: (tagId: string) => void;
  onBrandChange: (brandId: string) => void;
}

interface Brand {
  id: string;
  name: string;
}

interface Tag {
  id: string;
  tag: string;
}

export const SearchFilter = ({
  brands,
  tags,
  selectedTags = [],
  selectedBrands = [],
  onTagChange,
  onBrandChange,
}: Props) => {

  return (
    <div className="flex flex-col md:flex-row gap-6 py-4 px-6 border rounded-md">
      <div className="flex flex-col gap-2 w-full">
        <h6 className="text-neutral-800 tracking-tight dark:text-neutral-200 text-sm font-medium tracking-micro capitalize">
          タグ
        </h6>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-0.5 gap-x-3">
          {tags.map((tag) => (
            <label
              key={tag.id}
              className="flex items-center gap-2.5 select-none text-[13px] cursor-pointer text-neutral-600 hover:!text-pink-500 dark:text-neutral-400"
            >
              <input
                type="checkbox"
                checked={selectedTags.includes(tag.id)}
                onChange={() => onTagChange(tag.id)}
                className="border-neutral-200"
              />
              <span className="flex-1 truncate">#{tag.tag}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="flex flex-col gap-2 w-full">
        <h6 className="text-neutral-800 tracking-tight dark:text-neutral-200 text-sm font-medium tracking-micro capitalize">
          ブランド
        </h6>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-0.5 gap-x-3">
          {brands.map((brand) => (
            <label
              key={brand.id}
              className="flex items-center gap-2.5 select-none text-[13px] cursor-pointer text-neutral-600 hover:!text-pink-500"
            >
              <input
                type="checkbox"
                checked={selectedBrands.includes(brand.id)}
                onChange={() => onBrandChange(brand.id)}
                className="border-neutral-200"
              />
              <span className="flex-1 truncate">{brand.name}</span>
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};
